import { render, staticRenderFns } from "./facebookPage.vue?vue&type=template&id=67a150fe"
import script from "./facebookPage.vue?vue&type=script&lang=js"
export * from "./facebookPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports